import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import './WishCard.component.scss';
import { getAssetUrl } from '../../../utils/GetAssetUrl';
import {
  TWishStatus,
  EWishStatus,
  IWishCard,
} from '../../../domain/wish.interface';
import { square250 } from '../../../assets/images/base64-images';
import { urlFormatter, extractNameFromUrl } from '../../../utils/formatter';
import { formatNumberToCurrency } from '../../../utils/FormNormalizers';
import _ from 'lodash';

function CardPrice(props: any) {
  return (
    <div className='wish-card-price'>{formatNumberToCurrency(props.price)}</div>
  );
}

function isBooked(status: TWishStatus) {
  return status === EWishStatus.BOOKED;
}

function BookedFragment() {
  return (
    <div className='book-container d-flex justify-content-center align-items-center'>
      <div className='text'>
        <FormattedMessage id={`common.wish.status_${EWishStatus.BOOKED}`} />
      </div>
    </div>
  );
}

export function WishCardComponent(props: IWishCard) {
  const {
    wish,
    readOnly,
    isLiked,
    likes,
    deleteItem,
    likeItem,
    bookItem,
    copyItem,
    shareItem,
    editItem,
  } = props;

  const { id, name, mainPhoto, description, url, store, price, status } = wish;
  const allowNavigation = !readOnly && !!editItem;

  return (
    <div
      className={`wish-card list-group-item d-flex ${
        allowNavigation ? 'editable' : ''
      }`}
    >
      <div className='left-container'>
        <div
          className='image-container'
          style={{
            backgroundImage: mainPhoto
              ? `url(${getAssetUrl.images(mainPhoto)})`
              : `url(${getAssetUrl.icons('REGALO_AMARILLO.svg')})`,
            backgroundSize: mainPhoto ? 'cover' : '70%',
          }}
        >
          <img src={square250} alt='' />
          {!_.isNil(status) && isBooked(status) && <BookedFragment />}
        </div>
        <div className='toast-container'>
          {price !== null && !isNaN(Number(price)) && (
            <CardPrice price={Number(price)} />
          )}
          {(store || url) && (
            <p className='wish-card-store'>
              {!!url ? (
                <span>
                  <FontAwesomeIcon icon='external-link-alt' />
                  <a
                    href={urlFormatter(url)}
                    onClick={(e: any) => e.stopPropagation()}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='ml-2'
                  >
                    {store ? store : extractNameFromUrl(url as string)}
                  </a>
                </span>
              ) : (
                <span
                  className='store-span'
                  onClick={(e: any) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {store}
                </span>
              )}
            </p>
          )}
        </div>
      </div>
      <div className='data-container center-container d-flex flex-column justify-content-between'>
        <div className='text-container'>
          <h5
            className='subtitle'
            style={{ cursor: allowNavigation ? 'pointer' : 'auto' }}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              return allowNavigation ? editItem(wish) : null;
            }}
          >
            {name}
          </h5>
          <p className='card-paragraph'>{description}</p>
        </div>
      </div>
      <div className='buttons-container'>
        {!readOnly && !!likeItem && (
          <div
            className={`card-button d-flex star ${isLiked ? '' : 'lowlighted'}`}
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              likeItem(id);
            }}
          >
            <FormattedMessage id='common.like' />{' '}
            <span className='likes'>{likes}</span>{' '}
            <FontAwesomeIcon icon='star' />
          </div>
        )}
        {!readOnly && !!shareItem && (
          <div
            className='card-button d-flex'
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              shareItem(id);
            }}
          >
            <FormattedMessage id='common.share' />{' '}
            <FontAwesomeIcon icon='share-alt' />
          </div>
        )}
        {!readOnly && !!deleteItem && (
          <div
            className='card-button d-flex'
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              deleteItem(id);
            }}
          >
            <FormattedMessage id='common.delete' />{' '}
            <FontAwesomeIcon icon='trash' />
          </div>
        )}
        {readOnly && !!copyItem && (
          <div
            className='card-button d-flex'
            onClick={(e: any) => {
              e.preventDefault();
              e.stopPropagation();
              copyItem(id);
            }}
          >
            <FormattedMessage id='common.copy' />{' '}
            <FontAwesomeIcon icon='copy' />
          </div>
        )}
        {!!bookItem &&
          (status === EWishStatus.AVAILABLE ||
            status === EWishStatus.BOOKED) && (
            <div
              className='card-button d-flex'
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                bookItem(id);
              }}
            >
              <FormattedMessage
                id={
                  status === EWishStatus.AVAILABLE
                    ? 'common.book'
                    : 'common.remove_book'
                }
              />{' '}
              <FontAwesomeIcon
                icon={status === EWishStatus.AVAILABLE ? 'lock' : 'lock-open'}
              />
            </div>
          )}
      </div>
    </div>
  );
}
